import { useState, useCallback } from 'react';

/**
 * Query state for a DataTable: page, pageSize, search, sort, order — merge-
 * patched rather than replaced, so `onQueryChange({ page: 2 })` doesn't have
 * to know about the other four fields.
 */
export function useListQuery(defaults = {}) {
  const [query, setQuery] = useState({ page: 1, pageSize: 20, search: '', sort: undefined, order: 'desc', ...defaults });

  const onQueryChange = useCallback((patch) => {
    setQuery((prev) => ({ ...prev, ...patch }));
  }, []);

  return [query, onQueryChange];
}

export default useListQuery;
